import $ from 'jquery';
import Parallax from './Parallax';
import BackgroundImage from './BackgroundImage';

function Banner(element) {
  this.element = element;
  this.$element = $(element);
  this.parallax = this.addParallax();
  this.bgImage = this.addBackgroundImage();
}

Banner.prototype = {
  addParallax() {
    // Add an element to add a background to, in addition to adding a parallax effect on scroll.
    this.$element.find('.node').prepend('<span class="parallax"></span>');
    return new Parallax(this.element, { targetSelector: '.parallax' });
  },
  addBackgroundImage() {
    return new BackgroundImage(this.element, { destSelector: '.parallax' });
  },
};

export default Banner;



// WEBPACK FOOTER //
// ./Banner.js